import React from "react";

const CloseButton = ({ closeToast }) => {
  return (
    <button
      onClick={closeToast}
      className="absolute top-1 right-1 toaster-close-button"
    >
      <img src="/icons/close-circle-toast.svg" alt="close" />
    </button>
  );
};

export default CloseButton;
